Ext.define('SA.view.sidebar.data.DataFoldersList', {
    alias: 'widget.data-folders-list',
    extend: 'Ext.Component',

    baseCls: 'sa-data-folders-list',

    tpl: [
        '<tpl for=".">',
            '<div class="sa-data-folders-list-package">{name:htmlEncode}</div>',
            '<tpl for="vendors">',
                '<tpl if="!imports">',
                    '<div class="sa-data-folders-list-vendor',
                        '<tpl if="!available"> sa-data-folders-list-vendor-disabled</tpl>',
                    '">{name:htmlEncode}</div>',
                '</tpl>',
                '<tpl for="datasets">',
                    '<button data-dataset="{id:htmlEncode}" <tpl if="!available">disabled </tpl>',
                        'class="sa-data-folders-list-dataset x-unselectable',
                            '<tpl if="import">',
                                ' sa-data-folders-list-dataset-is-import',
                            '<tpl else>',
                                ' sa-data-folders-list-dataset-is-non-import',
                            '</tpl>',
                            '<tpl if="permitWrapping"> sa-data-folders-list-dataset-wrapping</tpl>',
                        '"',
                    '>',
                        '<svg class="sa-data-folders-list-dataset-icon sa-data-folders-list-dataset-icon-closed"><use href="#sa-icon-folder-closed"></use></svg>',
                        '<svg class="sa-data-folders-list-dataset-icon sa-data-folders-list-dataset-icon-open"><use href="#sa-icon-folder-open"></use></svg>',
                        '<span class="sa-data-folders-list-dataset-name">{name:htmlEncode}</span>',
                    '</button>',
                '</tpl>',
            '</tpl>',
        '</tpl>'
    ],

    getImportFolderEls() {
        return this.el.query('.sa-data-folders-list-dataset-is-import');
    },

    getNonImportFolderEls() {
        return this.el.query('.sa-data-folders-list-dataset-is-non-import');
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-data-folders-list-dataset',
            scope: this,

            click: this.onItemClick,
            mouseout: this.onItemMouseOut,
            mouseover: this.onItemMouseOver
        });
    },

    onItemClick(ev, el) {
        var item = el.getAttribute('data-dataset');

        this.setSelected(this.selected === item ? null : item);
    },

    onItemMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-data-folders-list-dataset-hover');
    },

    onItemMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-data-folders-list-dataset-hover');
    },

    setSelected(dataset) {
        this.selected = dataset;

        this.el.down('.sa-data-folders-list-dataset-active')?.removeCls('sa-data-folders-list-dataset-active');

        if (dataset) {
            let el = this.el.query('.sa-data-folders-list-dataset').find(dom => dataset === dom.getAttribute('data-dataset'));

            Ext.fly(el).addCls('sa-data-folders-list-dataset-active');

            this.fireEvent('select', {dataset, el});
            return;
        }

        this.fireEvent('deselect');
    }
});